import { Box, Button, Dialog, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { TextInput } from '../inputs';
import { useReport } from '../../contexts/ReportContext';
import PhoneInput from '../inputs/PhoneInput';

interface ReportFooterDialogProps {
    address: string;
    phone: string;
    website: string;
    onSubmit: (address: string, phone: string, website: string) => void;
}

const ReportFooterDialog: React.FC<ReportFooterDialogProps> = ({ address: addressProp, phone: phoneProp, website: websiteProp, onSubmit }) => {

    const [address, setAddress] = useState<string>(addressProp);
    const [phone, setPhone] = useState<string>(phoneProp);
    const [website, setWebsite] = useState<string>(websiteProp);

    const {
        toggleFooterDialog,
        footerDialogOpen,

    } = useReport();

    useEffect(() => {
        setAddress(addressProp);
        setPhone(phoneProp);
        setWebsite(websiteProp);
    }, [addressProp, phoneProp, websiteProp]);

    const handleSubmit = () => {
        console.log('Form submitted:', { address, phone, website });
        toggleFooterDialog();
        onSubmit(address, phone, website);
    };

    return (
        <Dialog open={footerDialogOpen} onClose={toggleFooterDialog}>
            <Box
                component="form"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    width: 400,
                    padding: 2,
                    border: '1px solid #E0E0E0',
                    borderRadius: '8px',
                }}
                noValidate
                autoComplete="off"
            >
                <Typography variant="h6" textAlign={"left"}>Edit Footer</Typography>
                <Stack direction="column" alignItems="flex-end" justifyContent="space-between">
                    <TextInput
                        label="Address"
                        variant="outlined"
                        multiline
                        rows={4}
                        value={address}
                        onChange={(value: number | string) => setAddress(value as string)}
                        inputProps={{ maxLength: 100 }}
                        fullWidth
                        helperText={`${address.length}/100`}
                    />
                    <PhoneInput
                        label="Phone number"
                        value={phone}
                        onChange={(value: string) => setPhone(value)}
                        fullWidth
                        />
                    <TextInput
                        label="Website"
                        variant="outlined"
                        value={website}
                        onChange={(value: number | string) => setWebsite(value as string)}
                        fullWidth
                    />
                </Stack>


                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 2 }}>
                    <Button variant="outlined" color="whiteButton" onClick={toggleFooterDialog}>
                        Cancel
                    </Button>
                    <Button color="blackButton" onClick={handleSubmit}>
                        Save
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
};

export default ReportFooterDialog;
